export default "/assets/images/mila-air-specs.b9e95382aa7fc678.webp";